import { useEffect } from "react";
import Image from "components/Elements/Image/Image";
import Icon from "components/Elements/Icon/Icon";
import Button from "components/Elements/Button/Button";
import Login from "components/Structure/Login/Login";
import Signup from "components/Structure/Signup/Signup";
import { useContent } from "contexts/contentContext/contentContext";
import { useModal } from "contexts/modalContext/modalContext";
import { getLocalStorage, setLocalStorage } from "utils/globalLocalStorage";

import styles from "./inboxIncognitoModal.module.scss";

export const STORAGE_INCOGNITO_INBOX_MODAL_KEY = "incognitoInboxAppearances";
export const WEEK_IN_MS = 7 * 24 * 60 * 60 * 1000;

const InboxIncognitoModal = () => {
  const { getHtmlByKey, getTextByKey } = useContent();
  const { setModal } = useModal();

  const handleLogin = () => {
    setModal({ modal: Login, modalSize: "full-modal" });
  };

  const handleSignup = () => {
    setModal({ modal: Signup, modalSize: "full-modal" });
  };

  useEffect(() => {
    // Get existing timestamps from localStorage or initialize an empty array
    const appearancesStorage = getLocalStorage(
      STORAGE_INCOGNITO_INBOX_MODAL_KEY
    );

    const now = Date.now();

    if (!appearancesStorage) {
      setLocalStorage(STORAGE_INCOGNITO_INBOX_MODAL_KEY, JSON.stringify([now]));
    } else {
      const appearances = JSON.parse(appearancesStorage);
      // Get the current time
      // Filter out timestamps older than a week
      const recentAppearances = appearances.filter(
        (timestamp: string | number) => now - +timestamp < WEEK_IN_MS
      );
      // Add the current timestamp
      recentAppearances.push(now);
      // Save the updated list back to localStorage
      setLocalStorage(
        STORAGE_INCOGNITO_INBOX_MODAL_KEY,
        JSON.stringify(recentAppearances)
      );
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.imageSection}>
        <Image name="features/inbox" ext="png" />
      </div>
      <div className={styles.contentSection}>
        <h2>{getHtmlByKey("inbox-incognito-title")}</h2>
        <div className={styles.info}>
          <Icon name="inbox-icon" blue />
          <p>{getHtmlByKey("inbox-incognito-info")}</p>
        </div>
        <p className={styles.text}>{getHtmlByKey("inbox-incognito-text")}</p>
        <Button onClick={handleSignup} buttonClass={styles.signUp}>
          {getHtmlByKey("create-account")}
        </Button>
        <div className={styles.loginText}>
          {getHtmlByKey("already-a-member")}
          <button onClick={handleLogin}>{getTextByKey("login")}</button>
        </div>
      </div>
    </div>
  );
};

export default InboxIncognitoModal;
